export default "__VITE_ASSET__BIQxHaz6__"